import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BaseMobileHeader } from "@/common/AppMobileHeader";
import { useAppDispatch } from "@/services/store";
import { appRouterPaths } from "@/services/navigation";
import type { MenuSorterOptions } from "@/common/AppHeader/mobile/Components/Menu/MenuSorterList";
import type { FC } from "react";
import { setCurrentPerson } from "../../slice";
import { isPersonSelected } from "../../helpers";
import styles from "./styles.module.scss";

type Props = {
  sorter?: MenuSorterOptions;
  showSorter?: boolean;
  setSorter?: (sort: MenuSorterOptions) => void;
};

export const Header: FC<Props> = ({ setSorter = () => "", showSorter = false, sorter = null }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const personSelected = isPersonSelected();

  const backHandler = () => {
    dispatch(setCurrentPerson(null));
    navigate(appRouterPaths.contacts.base);
  };
  return (
    <div className={styles.header}>
      <BaseMobileHeader
        sorterMenuValue={sorter}
        onSorterMenuChange={setSorter}
        showSorter={showSorter}
        onClickTitle={personSelected ? backHandler : undefined}
        showBackArrow={personSelected}
        title={t("common.contacts")}
      />
    </div>
  );
};
